import {template as tpl, viewModel as ObjectSearch} from "../object/search";
import searchHtml from './search.html?raw';

export let template: string = tpl.replace(new RegExp(/<!-- {{TEMPLATE_ROW}} -->/, 'g'), searchHtml);

export class viewModel extends ObjectSearch {
    protected override getTableKeys(): string[] {
        return super.getTableKeys().concat('func');
    }
}
